export default {
  api_url: 'https://api.strix.com.ar',
  api_username:  '',
  default_password: '',
  google_key: 'AIzaSyD97borLfyeAMcfhI8flD3h821OcTfM_BI',
  nominatim_url: 'http://clnominatim01.lojackhq.com.ar/nominatim',
  clickgo_url: 'https://map.strix.com.ar/GeoReferencia2/GRService.svc/GetGeoRefByCoords',
  clickgo_token: '0E335347-54EB-4181-A0CB-30BF086BFC82'
}



// WEBPACK FOOTER //
// ./src/server_config.js